import { AvisLogo } from "../logo/AvisLogo";
import { Layout } from "./";

interface ILayoutPublicProps {
  className: string;
}

export function LayoutPublic(props: Readonly<ILayoutPublicProps>) {
  const { className } = props;

  return (
    <Layout
      className={className}
      horizontalMenuItems={[
        {
          key: "logo",
          className: "col-1",
          wrapCustomLayout: false,
          customLayout: () => <AvisLogo className="avis-logo" />,
        },
      ]}
      verticalMenuItems={[]}
    />
  );
}
